<!-- <head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<app-navbar-component></app-navbar-component>

<br> <br>

<h1 style="margin-left:0%"> Please fill the details for your next appointment </h1>
<button style="margin-left:95%" type="button" class="btn btn-warning btn-circle btn-lg" (click)="cancel()"><i
    class="fa fa-close"></i></button>

<div class="detail">
  <br>

  <div class="card" *ngFor="let data of patientd">

    <h1 style="margin-top:3%" class="ml-3 mb-0">Name : {{data.pat_name}}</h1>
    <br>
    <h1 class="ml-3 mb-0">
      Date of birth : {{data.dob|date :'dd-MMM-yyyy'}} </h1>
    <br><br>
  </div>

  <br> <br>
  <form #appointmentForm="ngForm" class="appointment p-3">

    <ng-template #rt let-r="result" let-t="term">
      {{ r.fullname}}
    </ng-template>
    <input type="search" #instance="ngbTypeahead" placeholder="Consulting Physician" class="form-control w-100"
      aria-label="Search" name="model" [(ngModel)]="model" [ngbTypeahead]="search" [resultTemplate]="rt"
      [inputFormatter]="formatter">

    <div class="form-inline mt-3">
      <div class="form-group w-30">
        <div class="input-group w-100">
          <input class="form-control m-0" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="model1" ngbDatepicker
            #d="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()" type="button">
              <span class="fa fa-calendar "></span>
            </button>
          </div>
        </div>
      </div>
      <div class="form-group ml-5">
        <div class="input-group" style="margin-left:20%">
          <input type="text" list="appointment['aptime']" #aptime="ngModel" class="form-control mt-0" id="aptControl"
            required name="aptime" [(ngModel)]="appointment.aptime" placeholder="HH:MM" class="form-control" required>
          <datalist id="appointment['aptime']">
            <option value="08:00" selected="">08.00 AM</option>
            <option value="08:30">08.30 AM</option>
            <option value="09:00">09.00 AM</option>
            <option value="09:30">09.30 AM</option>
            <option value="10:00">10.00 AM</option>
            <option value="10:30">10.30 AM</option>
            <option value="11:00">11.00 AM</option>
            <option value="11:30">11.30 AM</option>
            <option value="12:00">12.00 PM</option>
            <option value="12:30">12.30 PM</option>
            <option value="13:00">01.00 PM</option>
            <option value="13:30">01.30 PM</option>
            <option value="14:00">02.00 PM</option>
            <option value="14:30">02.30 PM</option>
            <option value="15:00">03.00 PM</option>
            <option value="15:30">03.30 PM</option>
            <option value="16:00">04.00 PM</option>
            <option value="16:30">04.30 PM</option>
            <option value="17:00">05.00 PM</option>
            <option value="17:30">05.30 PM</option>
            <option value="18:00">06.00 PM</option>
            <option value="18:30">06.30 PM</option>
            <option value="19:00">07.00 PM</option>
            <option value="19:30">07.30 PM</option>
            <option value="20:00">08.00 PM</option>
            <option value="20:30">08.30 PM</option>
            <option value="21:00">09.00 PM</option>
            <option value="21:30">09.30 PM</option>
            <option value="22:00">10.00 PM</option>
            <option value="22:30">10.30 PM</option>

          </datalist>
        </div>
      </div>
    </div>

    <br><br><br><br>
    <div>
      <button class="primary-btn" type="submit" name="submit" (click)="Save(appointmentForm.value)"
        (click)="cancel()">Re-Schedule</button>
      <button class="primary-btn" type="submit" name="submit" (click)="deleteAppoint()" (click)="cancel()">Delete
        Appointment</button>
    </div>
  </form>

</div> -->

<div class="container-fluid wrapper-page">
  <div align="center">
    <h4 class="mt-2 mb-2">MODIFY APPOINTMENT</h4>
  </div>
  <div>
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">

          <div class="row">
            <div class="col-lg-4">
              <h6 style="text-align: center;">PATIENT INFORMATION</h6><br>
              <div style="text-align: center;">
                <img src="{{p_purl}}" onerror="this.src='assets/new-ui/images/users/avatar.jpg'" class="image">
              </div>
              <div class="user_card">
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Name:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{patientd[0]?.patient_first_name || 'NA'}}
                      {{patientd[0]?.patient_last_name}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Patient ID:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{patientd[0]?.pid || 'NA'}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Gender:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{patientd[0]?.gender || 'NA'}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Date of Birth:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{(patientd[0]?.dob | date:'dd-MM-yyyy') || 'NA'}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Address:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{patientd[0]?.address_1 || 'NA'}}</label>

                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Contact:</label>
                  </div>
                  <div class="col-7">

                    <label class="label2">{{patientd[0]?.contact_no || 'NA'}}</label>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-md-8">

              <form [formGroup]="rescheduleAppointmentForm">
                <div class="row" style="margin-top: 18px;">
                  <div class="mb-3" style="text-align: center;">
                    <h6>SCHEDULING INFORMATION</h6> <br>
                    <div class="form-check form-check-inline">
                      <input id="false" type="radio" class="form-check-input" value='false' name="scheduleOptions"
                        formControlName="scheduleOptions" (click)="signUpUser(0)" />
                      <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio1">Inperson</label>
                    </div>
                    <div class="form-check form-check-inline ml-5">
                      <input id="true" type="radio" class="form-check-input" value='true' name="scheduleOptions"
                        formControlName="scheduleOptions" (click)="signUpUser(1)" />
                      <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio2">Online</label>
                    </div>
                  </div>
                </div><br>
                <p>Physician Name:</p>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <select name="model" formControlName="drid" class="form-control select">
                      <option *ngFor="let p of physician" [value]="p?.u_id">
                        {{p.fullname}}
                      </option>
                    </select>
                    <div *ngIf="rescheduleAppointmentForm.get('drid').hasError('required')" class="invalid-feedback">
                      Physician name is required
                    </div>
                  </div>
                </div><br>
                <p>Appointment Date and Time:</p>
                <div class="row mb-3">
                  <div class="col-md-6 col-lg-5">
                    <div class="input-group m-t-10">
                      <div class="d-flex">
                        <input class="form-control" placeholder="Start Date(DD/MM/YYYY)" name="startDate"
                          formControlName="startDate" ngbDatepicker #sd="ngbDatepicker"
                          (dateSelect)="dateTimeChangeEvent()" data-date-inline-picker="false" id="startDate"
                          [minDate]="currentDate" />
                        <div>
                          <button class="btn btn-outline-secondary calendar rounded-0" (click)="sd.toggle()"
                            type="button" style="line-height: 2.5;" id="startDateButton">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                      </div>
                      <div *ngIf="rescheduleAppointmentForm.get('startDate').hasError('required')"
                        class="invalid-feedback">
                        Start Date is required
                      </div>
                      <div
                        *ngIf="rescheduleAppointmentForm.controls['startDate'].touched && rescheduleAppointmentForm.get('startDate').hasError('ngbDate')"
                        class="invalid-feedback"> Start Date is invalid
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-5" *ngIf="scheduleOptions != 1">
                    <div class="input-group m-t-10">
                      <div class="d-flex">
                        <input class="form-control" placeholder="End Date(DD/MM/YYYY)" name="endDate"
                          formControlName="endDate" ngbDatepicker #ed="ngbDatepicker" data-date-inline-picker="false"
                          id="endDate" [minDate]="rescheduleAppointmentForm.value.startDate || currentDate" />
                        <div>
                          <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()"
                            type="button" style="line-height: 2.5;" id="endDateButton">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                      </div>
                      <div *ngIf="rescheduleAppointmentForm.get('endDate').hasError('ngbDate')"
                        class="invalid-feedback">
                        End Date is invalid
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-lg-5">
                    <label>Start Time</label>
                    <ngb-timepicker formControlName="startTime" meridian=true (ngModelChange)="dateTimeChangeEvent()">
                    </ngb-timepicker>
                    <div *ngIf="rescheduleAppointmentForm.get('startTime').hasError('required')"
                      class="invalid-feedback">
                      Start Time is required
                    </div>
                    <div *ngIf="rescheduleAppointmentForm.get('startTime').hasError('invalidStartTime')"
                      class="invalid-feedback"> Start Time is invalid
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-5">
                    <label>End Time</label>
                    <ngb-timepicker formControlName="endTime" meridian=true (ngModelChange)="validateEndTime()">
                    </ngb-timepicker>
                    <div *ngIf="rescheduleAppointmentForm.get('endTime').hasError('invalidEndTime')"
                      class="invalid-feedback">
                      End-Time should be greater than Start-Time
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 col-xl-2 my-auto pt-5 pl-0 ">
                    <button type="button" class="btn btn-primary border btn-rounded px-3"
                      [disabled]="!rescheduleAppointmentForm.value.drid" (click)="openCalendarMOdal()">View
                      calendar</button>
                  </div>
                </div>




              </form>
            </div>



            <!--
            <div class="col-md-8">
              <h6 style="text-align: center;">PHYSICIAN INFORMATION</h6><br>
              <div class="row" style="margin-top: 18px;">
                <select name="model" [(ngModel)]="model" class="form-control select">
                  <option *ngFor="let p of physician" [value]="p.u_id">
                    {{p.fullname}}
                  </option>
                </select>

              </div><br>
              <p>Appointment Date and Time</p><br>
              <div class="row">
                <div class="col-sm-5">
                  <div input-group col-md-4 m-t-10>
                    <div class="d-flex">
                      <input class="form-control" placeholder="DD/MM/YYYY" name="model1" [(ngModel)]="model1"
                        ngbDatepicker #d="ngbDatepicker" data-date-inline-picker="false" id="inputDate"
                        [minDate]="minDate" />
                      <div>
                        <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()" type="button"
                          style="line-height: 2.5;" id="dateButton">
                          <span class="fa fa-calendar"></span>
                        </button>
                      </div>
                    </div>
                    <ngb-timepicker [(ngModel)]="time1" meridian=true></ngb-timepicker>


                    <div *ngIf="isError" class="invalid-feedback">Invalid date</div>


                  </div>

                </div>
                <div class="col-sm-5">
                  <div input-group col-md-4 m-t-10>
                    <div class="d-flex">
                      <input class="form-control" placeholder="DD/MM/YYYY" name="model1" [(ngModel)]="model1"
                        ngbDatepicker #d="ngbDatepicker" data-date-inline-picker="false" id="inputDate"
                        [minDate]="minDate" />
                      <div>
                        <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()" type="button"
                          style="line-height: 2.5;" id="dateButton">
                          <span class="fa fa-calendar"></span>
                        </button>
                      </div>
                    </div>
                    <ngb-timepicker [(ngModel)]="time1" meridian=true></ngb-timepicker>


                    <div *ngIf="isError" class="invalid-feedback">Invalid date</div>


                  </div>

                </div>
                <div class="col-sm-2 my-auto pt-5 pl-0 ">
                  <button type="button" class="btn btn-primary border btn-rounded pr-1 pl-1">View calendar</button>
                </div>
              </div>

            </div> -->
            <div class="col-md-3">
            </div>
          </div><br><br>
          <div class="row" style="margin-bottom: 75px;">

            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-md-right">
              <button type="button" class="btn btn-danger border btn-rounded" (click)="deleteAppoint()">DELETE
                APPOINTMENT</button>
            </div>
            <div class="col-lg-8 col-md-4 col-sm-12 col-xs-12">
              <button type="button" class="btn btn-primary border btn-rounded"
                [disabled]="rescheduleAppointmentForm.invalid"
                (click)="reScheduleAppointment(rescheduleAppointmentForm.value)">RE-SCHEDULE APPOINTMENT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<!--end container-->